import { SessionCustomer } from '@cld/session-service';
import { CUSTOMER_ID_PREFIX_FOR_URL } from '@cld/application-wrapper-common';

export const getExternalIdWithPrefixForUrl = (customer: SessionCustomer) => `/${CUSTOMER_ID_PREFIX_FOR_URL}${customer.externalId}`;

export const extendCustomer = (customer?: SessionCustomer) => {
  if (!customer) {
    return customer;
  }

  return {
    ...customer,
    externalIdForUrl: getExternalIdWithPrefixForUrl(customer),
  };
};
